import "./styles/main.css";
import "./js/carousel.js";

console.log("Webpack + Tailwind CSS loaded successfully!");

// Your JavaScript code here
